import { HeartFilled } from '@ghosts-inc/design-system/icons';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import { PageContext, SectionContext } from '@/analytics/analytics.types';
import { useFavoriteHeart } from './useFavoriteHeart';

// set color to 75% opacity when not favorited
const opacify = (color: string, on: boolean) => {
  return color + (on ? 'FF' : 'BF');
};

const FavoriteHeart = ({
  analyticsInfo,
  listingId,
  isFavorite: initialFavoriteState,
  onFavoriteClick,
}: {
  analyticsInfo?: {
    context?: PageContext & SectionContext;
  };
  listingId: number;
  isFavorite?: boolean;
  onFavoriteClick?: () => void;
}): JSX.Element => {
  const theme = useTheme();

  const { toggle, isFavorite } = useFavoriteHeart({
    analyticsInfo,
    initialFavoriteState,
    listingId,
    onFavoriteClick,
  });

  const color = isFavorite ? theme.palette.error : theme.palette.surface;

  return (
    <IconButton onClick={toggle}>
      <HeartFilled
        data-testid="favorite-heart"
        data-filled={isFavorite}
        htmlColor={opacify(color.main, isFavorite)}
        sx={{
          '&:hover': {
            color: opacify(color.dark, isFavorite),
          },
        }}
      />
    </IconButton>
  );
};

export default FavoriteHeart;
